import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import LogoFallback from "/assets/img/bubbanlogo.jpg";
import axios from "axios";

export default function EngPage({
  logoSrc = LogoFallback,
  accent = "#115e32",
  pageTitle = "Bachelor of Arts in English | Program | Bandarban University",
}) {
	const [data, setData] = useState({});
	const [openSemester, setOpenSemester] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	
	const coursePost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:"3",
				programme_id:"1",
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/program-syllabus", payload);
			
			setData(response.data || []);
			
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	useEffect(() => {
		coursePost();		
	}, []);
	
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
	
	const toggleSemester = (sem) => {
		setOpenSemester(openSemester === sem ? null : sem);
	};

	const program = {
		program:"Bachelor of Arts in English",
		duration:"4 Years",
		semester:"8",
		credit:"155 (Foundation: 12, GED/Allied:36, Core:78)",
		admission:"10000 (Once)",
		semester_fee:"5000 (Per Semester)",
		establihsment:"2000 (Per Semester)",
		library:"100 (Once)",
		lab:"500 (Per Semester)",
		exam:"100 (Per Credit)",
		tuition:"1031 (Per Credit)",
		total:"2,46,305/=",
	};
	
	return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-700 to-teal-500  text-white py-20 text-center px-6">
        <motion.h1
          className="text-4xl md:text-5xl font-bold mb-4"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
        >
          Bachelor of Arts in English
        </motion.h1>
        <motion.p
          className="max-w-3xl mx-auto text-lg opacity-90"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Preparing students with cutting-edge skills, research knowledge, and
          innovation in technology.
        </motion.p>
      </section>

      {/* Course Features */}
      <section className="max-w-6xl mx-auto py-12 px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[
          { label: "Total Cost", value: "2,46,305 Tk." },
          { label: "Total Credit Hours", value: "155" },
          { label: "Level", value: "Undergraduate" },
          { label: "Semester", value: "January, July" },
          { label: "Duration", value: "4 Years" },
          { label: "Language", value: "English" },
        ].map((item, i) => (
          <motion.div
            key={i}
            className="bg-white p-6 rounded-xl shadow-md text-center"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: i * 0.1 }}
          >
            <h3 className="text-lg font-semibold text-gray-700">
              {item.label}
            </h3>
            <p className="text-indigo-600 text-xl font-bold">{item.value}</p>
          </motion.div>
        ))}
      </section>
	    <section className="py-12 bg-gradient-to-r from-green-50 to-green-100">
		  <div className="container mx-auto px-4">
			{/* Section Header */}
			<h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
			  Program Information
			</h2>

			{/* Card */}
			<div className="bg-white shadow-lg rounded-2xl overflow-hidden">
			  {/* Program Title */}
			  <div className="bg-green-600 text-white px-6 py-4">
				<h3 className="text-xl font-semibold">{program.program}</h3>
			  </div>

			  {/* Program Body */}
			  <div className="p-6">
				<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
				  <div>
					<p>
					  <span className="font-semibold">Duration:</span>{" "}
					  {program.duration}
					</p>
					<p>
					  <span className="font-semibold">Semester:</span>{" "}
					  {program.semester}
					</p>
					<p>
					  <span className="font-semibold">Credit:</span>{" "}
					  {program.credit}
					</p>
				  </div>

				  <div>
					<p>
					  <span className="font-semibold">Admission Fee:</span>{" "}
					  {program.admission}
					</p>
					<p>
					  <span className="font-semibold">Semester Fee:</span>{" "}
					  {program.semester_fee}
					</p>
					<p>
					  <span className="font-semibold">Establishment Fee:</span>{" "}
					  {program.establihsment}
					</p>
				  </div>

				  <div>
					<p>
					  <span className="font-semibold">Library Fee:</span>{" "}
					  {program.library}
					</p>
					<p>
					  <span className="font-semibold">Lab Fee:</span>{" "}
					  {program.lab}
					</p>
					<p>
					  <span className="font-semibold">Exam Fee:</span>{" "}
					  {program.exam}
					</p>
				  </div>

				  <div>
					<p>
					  <span className="font-semibold">Tuition Fee:</span>{" "}
					  {program.tuition}
					</p>
					<p className="text-lg font-bold text-green-700 mt-4">
					  Total Cost: {program.total}
					</p>
				  </div>
				</div>
			  </div>
			</div>
		  </div>
		</section>
      <div className="text-center mb-12">
        <Link to="https://web.bubban.ac.bd/home/apply-online" className="px-6 py-3 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition">
          Apply Now
        </Link>
      </div>

      {/* Program Image */}
      <section className="max-w-6xl mx-auto mb-12 px-6">
        <img
          src="/assets/img/ell.jpg"
          alt="Program Banner"
          className="rounded-2xl shadow-lg"
        />
      </section>

      {/* Overview */}
     

      {/* Entry, Assessment, Graduate Attributes */}
      <section className="max-w-6xl mx-auto px-6 mb-12 space-y-8">
        <div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Entry Requirements
          </h2>
          <ul className="list-disc ml-6 text-gray-600">
			<li><span>1</span> Total CGPA of SSC and HSC must be no less than 6.00 and the individual CGPA must be no less than 2.50.</li>
			<li><span>2</span> In O-level exam, there must be five subjects and in A-level, there must be two subjects. Among the seven subjects, there must be four B grade or gpa 4.00 and three C grade or 3.5 for the admission.</li>
			<li><span>3</span> In case of the descendent of freedom fighters, total CGPA of SSC and HSC must be 5.00</li>
			<li><span>4</span> Study background must be Science/Arts/Commerce.</li>
			<li><span>5</span> Students will be recruited through an admission test.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Assessment Criteria
          </h2>
          <p className="text-gray-600">
			Each course is assessed in 100 Marks with a breakdown of class tests, presentations, mid-term and final exams and viva-voce as follow:
            <br/><strong>Class Test/ Assignment:</strong> 10
			<br/><strong>Attendance:</strong> 10
			<br/><strong>Class Performacne:</strong> 10											
			<br/><strong>Mid-term exam:</strong> 20
			<br/><strong>Final exam:</strong> 50
			<br/><strong>Total:</strong> 100
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Graduate Attributes
          </h2>
			<p className="text-gray-600">
				Given the pervasiveness of computer technology in today's society, there are many different job options open to the computer science major. The right job for you will depend on your personal skills, values, and interests.
			</p>
          <ul className="list-disc ml-6 text-gray-600">
            
          </ul>
        </div>
      </section>

      {/* Semester Wise Courses */}
      <section className="max-w-6xl mx-auto px-6 pb-16">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">
          Semester-wise Courses
        </h2>

        {Object.entries(data).map(([semester, courses], idx) => (
        <div
          key={idx}
          className="mb-6 border border-green-700 rounded-xl shadow-sm bg-white overflow-hidden"
        >
          {/* Accordion Header */}
          <button
            onClick={() => toggleSemester(semester)}
            className="w-full flex justify-between items-center px-6 py-4  font-semibold text-lg"
          >
            {semester}
            <span>{openSemester === semester ? "▲" : "▼"}</span>
          </button>

          {/* Accordion Body */}
          <AnimatePresence initial={false}>
            {openSemester === semester && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="overflow-hidden"
              >
                <div className="p-6">
                  <table className="w-full border rounded-lg overflow-hidden shadow-md">
                    <thead className="bg-green-600 text-white">
                      <tr>
                        <th className="p-3 text-left">SL</th>
                        <th className="p-3 text-left">Course Code</th>
                        <th className="p-3 text-left">Course Title</th>
                        <th className="p-3 text-left">Credit Hours</th>
                        <th className="p-3 text-left">Pre-requisite</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {courses.map((course) => (
                        <tr key={course.sl}>
                          <td className="p-3">{course.sl}</td>
                          <td className="p-3">{course.actual_code}</td>
                          <td className="p-3">{course.course_title}</td>
                          <td className="p-3">{course.credit_hours}</td>
                          <td className="p-3">
                            {course.pre_requisite || "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
      </section>
    </div>
  );
}
